import { orchestrator } from 'satcheljs';
import { setIsComplete } from '../actions';
import patchAsset from '../utils/patchAsset';

orchestrator(setIsComplete, ({ projectId, assetId, isComplete, wasPreviouslyComplete }) => {
    patchAsset(
        projectId,
        assetId,
        { isComplete: !!isComplete },
        { isComplete: wasPreviouslyComplete },
        () => isComplete !== wasPreviouslyComplete
    );
});
